/** Separates human-facing chat copy from optional technical stdout (lint, git, …). */
export const STUDIO_TECHNICAL_DETAILS_MARKER = '\n<!--studio-technical-->\n';

export type SplitStudioNotice = {
  readonly summary: string;
  readonly technicalDetails: string | undefined;
};

export function withTechnicalDetails(summary: string, details: string): string {
  const trimmed = details.trim();
  if (trimmed === '') {
    return summary;
  }
  return `${summary}${STUDIO_TECHNICAL_DETAILS_MARKER}${trimmed}`;
}

export function splitStudioNotice(text: string): SplitStudioNotice {
  const marker = '<!--studio-technical-->';
  const index = text.indexOf(marker);
  if (index === -1) {
    return { summary: text, technicalDetails: undefined };
  }
  return {
    summary: text.slice(0, index).trimEnd(),
    technicalDetails: text.slice(index + marker.length).replace(/^\n/, ''),
  };
}
